import React from "react";
import { Pencil, Power } from "lucide-react";

import TableV2 from "src/components/ui/TableV2";
import { Badge } from "src/components/ui/Badge";
import { formatDateTime } from "src/utils/date-time";
import { formatCreatedBy } from "src/utils/common";

interface TenantUserListTableProps {
  data: any[];
  pagination?: any;
  onPageChange: (page: number) => void;
  onEdit?: (row: any) => void;
  onToggleStatus?: (row: any) => void;
  canEdit?: boolean;
  canToggle?: boolean;
}

const TenantUserListTable: React.FC<TenantUserListTableProps> = ({
  data,
  pagination,
  onPageChange,
  onEdit,
  onToggleStatus,
  canEdit = false,
  canToggle = false,
}) => {
  return (
    <TableV2
      columns={[
        {
          key: "name",
          header: "Name",
          accessor: ({ row }) => (
            <div className="w-20">
              {row["firstName"] + " " + row["lastName"]}
            </div>
          ),
        },
        { key: "email", header: "Email" },
        { key: "gender", header: "Gender" },
        {
          key: "role",
          header: "Role",
          accessor: ({ row }) => <div>{row?.role?.name || row?.role}</div>,
        },
        {
          key: "createdBy",
          header: "Created By",
          accessor: ({ row }) => formatCreatedBy(row?.createdBy),
        },
        {
          key: "createdAt",
          header: "Created At",
          accessor: ({ key, row }) => (
            <div>{formatDateTime(row[key], "DD/MM/YYYY")}</div>
          ),
        },
        {
          key: "status",
          header: "Status",
          accessor: ({ key, row }) => (
            <Badge
              text={row?.[key] || ""}
              color={row?.[key] === "active" ? "green" : "red"}
            />
          ),
        },
        {
          key: "actions",
          header: "Actions",
          accessor: ({ row }) => (
            <div className="pr-2">
              {canEdit && (
                <button
                  className="p-2 rounded-md hover:bg-primary-100 text-primary-600"
                  onClick={() => onEdit?.(row)}
                >
                  <Pencil size={14} />
                </button>
              )}
              {canToggle && (
                <button
                  className={`p-2 rounded-md ${
                    row.status === "active"
                      ? "hover:bg-red-100 text-red-600"
                      : "hover:bg-green-100 text-green-600"
                  }`}
                  onClick={() => onToggleStatus?.(row)}
                >
                  <Power size={14} />
                </button>
              )}
            </div>
          ),
        },
      ]}
      data={data}
      pagination={pagination}
      onPageChange={onPageChange}
    />
  );
};

export default TenantUserListTable;
